/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homeherosub2Inputs */



/**
* | output |
* | --- |
* | "Central registration platform for DMUN conferences" |
*
* @param {Homeherosub2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const homeherosub2 = /** @type {((inputs?: Homeherosub2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homeherosub2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Central registration platform for DMUN conferences")
	return /** @type {LocalizedString} */ ("Gemeinsame Bewerbungsplattform für MUN-SH und MUNBW")
});
export { homeherosub2 as "homeHeroSub" }